// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Core__JSON from "@rescript/core/src/Core__JSON.bs.js";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";

var obj = Core__JSON.Decode.object;

function get(dict, key) {
  return Core__Option.flatMap(dict, (function (__x) {
                return __x[key];
              }));
}

function string(dict, key) {
  return Core__Option.flatMap(get(dict, key), Core__JSON.Decode.string);
}

function $$float(dict, key) {
  return Core__Option.flatMap(get(dict, key), Core__JSON.Decode.$$float);
}

function $$int(dict, key) {
  return Core__Option.map(Core__Option.flatMap(get(dict, key), Core__JSON.Decode.$$float), (function (prim) {
                return prim | 0;
              }));
}

function bool(dict, key) {
  return Core__Option.flatMap(get(dict, key), Core__JSON.Decode.bool);
}

function array(dict, key) {
  return Core__Option.flatMap(get(dict, key), Core__JSON.Decode.array);
}

function object(dict, key) {
  return Core__Option.flatMap(get(dict, key), Core__JSON.Decode.object);
}

export {
  obj ,
  get ,
  string ,
  $$float ,
  $$int ,
  bool ,
  array ,
  object ,
}
/* No side effect */
